import styled from 'styled-components';

const WorkspaceCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 115px;
  padding: 10px 15px 15px 15px;
`;

const WorkspaceCardHeader = styled.div`
  display: flex;
  margin-bottom: 10px;
  font-size: 20px;
  line-height: 34px;
  color: ${(props) => props.theme['color.text.title']};
`;

const WorkspaceCardTitle = styled.div`
  width: calc(100% - 50px);
  padding-left: 5px;
  overflow: hidden;
  white-space:nowrap;
  text-overflow: ellipsis;
`;

const WorkspaceCardContent = styled.div`
  display: flex;
`;

export {
  WorkspaceCardContainer,
  WorkspaceCardHeader,
  WorkspaceCardTitle,
  WorkspaceCardContent,
};
